import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TournamentsRepository } from '../services/repository';
import TournamentDetails from './TournamentDetails.jsx';
import TournamentSummary from './TournamentSummary.jsx';
import { showSnackbar } from './Snackbar.jsx';
import './TournamentRouter.css';

const TournamentRouter = () => {
    const { id } = useParams();
    const [tournament, setTournament] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isFinished, setIsFinished] = useState(false);

    useEffect(() => {
        if (id) {
            loadTournament();
        }
    }, [id]);

    const loadTournament = async () => {
        try {
            setLoading(true);
            const tournamentData = await TournamentsRepository.fetchTournament(id);
            setTournament(tournamentData);
            
            // Check if tournament is finished
            const finished = tournamentData.finishedAt !== null && tournamentData.finishedAt !== undefined;
            setIsFinished(finished);
        } catch (error) {
            console.error('Error loading tournament:', error);
            showSnackbar('Błąd ładowania turnieju');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="tournament-router-container">
                <div className="loading-message">Ładowanie turnieju...</div>
            </div>
        );
    }

    if (!tournament) {
        return (
            <div className="tournament-router-container">
                <div className="error-message">Turniej nie został znaleziony</div>
            </div>
        );
    }

    // Route to appropriate component based on tournament status
    if (isFinished) {
        return <TournamentSummary />;
    } else {
        return <TournamentDetails />;
    }
};

export default TournamentRouter;
